/** نطاقات success_rate_pct مثل متوسط الجلسة */
export function aggregateChallengesReportCharts(rows, formatLevelName) {
  const levelMap = new Map();
  const deptMap = new Map();
  const buckets = { '0-25': 0, '25-50': 0, '50-75': 0, '75-100': 0, '?': 0 };

  for (const raw of rows) {
    const totalChallenges = raw.total_challenges ?? raw.totalChallenges;
    const successPct = raw.success_rate_pct ?? raw.successRatePct;
    const r = { ...raw, total_challenges: totalChallenges, success_rate_pct: successPct };

    const lvl = r.soroban_level_name
      ? formatLevelName(r.soroban_level_name)
      : r.soroban_level_number != null
        ? String(r.soroban_level_number)
        : null;
    const levelKey = lvl || '—';
    levelMap.set(levelKey, (levelMap.get(levelKey) || 0) + 1);

    const dept = (r.department_name && String(r.department_name).trim()) || '—';
    const prev = deptMap.get(dept) || { students: 0, totalChallenges: 0 };
    prev.students += 1;
    prev.totalChallenges += Number(r.total_challenges) || 0;
    deptMap.set(dept, prev);

    const p = Number(r.success_rate_pct);
    if (Number.isNaN(p) || r.success_rate_pct == null || r.success_rate_pct === '') buckets['?'] += 1;
    else if (p < 25) buckets['0-25'] += 1;
    else if (p < 50) buckets['25-50'] += 1;
    else if (p < 75) buckets['50-75'] += 1;
    else buckets['75-100'] += 1;
  }

  const byLevel = [...levelMap.entries()]
    .map(([name, count]) => ({ name, count }))
    .sort((a, b) => b.count - a.count);

  const byDept = [...deptMap.entries()]
    .map(([name, v]) => ({ name, students: v.students, totalChallenges: v.totalChallenges }))
    .sort((a, b) => b.totalChallenges - a.totalChallenges)
    .slice(0, 12);

  const bucketOrder = ['0-25', '25-50', '50-75', '75-100', '?'];
  const bySuccessBucket = bucketOrder.map((key) => ({ key, count: buckets[key] }));

  return { byLevel, byDept, bySuccessBucket };
}

function csvEscapeCell(value) {
  const s = value == null ? '' : String(value);
  if (/[",\r\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

const BUCKET_I18N = {
  '0-25': 'chartBucket_0_25',
  '25-50': 'chartBucket_25_50',
  '50-75': 'chartBucket_50_75',
  '75-100': 'chartBucket_75_100',
  '?': 'chartBucket_unknown'
};

export function buildChallengesChartCsvAppend(rows, formatLevelName, t) {
  if (!rows || rows.length === 0) return '';
  const { byLevel, byDept, bySuccessBucket } = aggregateChallengesReportCharts(rows, formatLevelName);
  const lines = ['', csvEscapeCell(t('reports.challengesCharts.csvBlockTitle')), ''];

  lines.push(csvEscapeCell(t('reports.challengesCharts.chartByLevelTitle')));
  lines.push(
    [t('reports.dailyExercisesApi.colLevel'), t('reports.dailyExercisesApi.chartStudentCount')]
      .map(csvEscapeCell)
      .join(',')
  );
  for (const row of byLevel) {
    lines.push([row.name, row.count].map(csvEscapeCell).join(','));
  }

  lines.push('');
  lines.push(csvEscapeCell(t('reports.challengesCharts.chartByDeptChallengesTitle')));
  lines.push(
    [
      t('reports.dailyExercisesApi.colDepartment'),
      t('reports.dailyExercisesApi.chartStudentCount'),
      t('reports.challengesCharts.colSumChallenges')
    ]
      .map(csvEscapeCell)
      .join(',')
  );
  for (const row of byDept) {
    lines.push([row.name, row.students, row.totalChallenges].map(csvEscapeCell).join(','));
  }

  lines.push('');
  lines.push(csvEscapeCell(t('reports.challengesCharts.chartSuccessPieTitle')));
  lines.push(
    [t('reports.dailyExercisesApi.chartRangeLabel'), t('reports.dailyExercisesApi.chartStudentCount')]
      .map(csvEscapeCell)
      .join(',')
  );
  for (const row of bySuccessBucket) {
    const labelKey = `reports.dailyExercisesApi.${BUCKET_I18N[row.key] || 'chartBucket_unknown'}`;
    lines.push([t(labelKey), row.count].map(csvEscapeCell).join(','));
  }

  return `\r\n${lines.join('\r\n')}`;
}
